import { RootState } from "app.store";
import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { DefaultErrorMessage } from "shared/constants/message";
import { getShoppingCart } from "shared/plugins/http-service";
import { SetCart } from "states/cart/cart.action";
import { getCartApi } from "states/cart/cart.api";
import { globalValueSetToast } from "states/global-value/global-value.action";
import { ToastModel, ToastType } from "states/global-value/global-value.models";
import _ from "lodash";
const CartManagement = () => {
  const dispatch = useDispatch();
  const isAuthentication = useSelector(
    (state: RootState) => state.account.isAuthentication,
    shallowEqual
  );
  const isGetCart = useSelector(
    (state: RootState) => state.globalValue.isGetCart
  );
  const getCart = async () => {
    try {
      let result = await getCartApi();
      dispatch(SetCart(result.data));
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message ?? DefaultErrorMessage,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  useEffect(() => {
    if (isAuthentication) {
      getCart();
    } else {
      let shoppingCart = getShoppingCart();
      if (shoppingCart !== null && shoppingCart !== "") {
        dispatch(SetCart(JSON.parse(shoppingCart ?? "")));
      }
    }
  }, [isAuthentication, isGetCart]);
  return null;
};

export default CartManagement;
